import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() data!: any;
  constructor(private homeService: HomeService, private router: Router) {}

  handleViewDashboard(id: string, name: string) {
    this.homeService.setEngagementId(id);
    this.homeService.setClientName(name);
    this.router.navigate(['/home/' + id]);
  }
  ngOnInit(): void {}

  ngOnDestroy(){
    this.homeService.setEngagementId('');
  }

  formatClientName(clientName: string): string {
    return clientName.toLowerCase().replace(/\s+/g, '-');
  }
}
